import { useInnerRouter } from './Provider'

type IInnerRouteProps = {
  path: string
}

const InnerRoute = (props: React.PropsWithChildren<IInnerRouteProps>) => {
  const { currentPath } = useInnerRouter()

  if (currentPath !== props.path) {
    return null
  }
  return <>{props.children}</>
}

export default InnerRoute
